<edu-card class="settings-card">
  <h2 edu-card-title>External Calendar</h2>

  <!-- Loading state -->
  <div class="loading-state" *ngIf="loading">
    <div class="spinner"></div>
    <p>Loading calendar sync...</p>
  </div>

  @if (!loading) {
    <div class="integration-card">
      <div class="integration-content">
        <div class="integration-header">
          <div class="integration-info">
            <div class="integration-icon" [class.linked]="enabled">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
            </div>
            <div class="integration-details">
              <div class="name-status">
                <h3 class="integration-name">Class Calendar</h3>
                <span class="status-badge" *ngIf="enabled">On</span>
                <span class="status-badge error" *ngIf="!enabled">Off</span>
              </div>
              <p class="integration-description">
                Show your class schedule in Google, Apple, or Outlook Calendar.
                Schedule changes sync automatically.
              </p>
            </div>
          </div>
          <div class="button-group">
            <button class="link-button" *ngIf="!enabled" (click)="enable()" [disabled]="working">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Turn on
            </button>
            <button class="unlink-button" *ngIf="enabled" (click)="disable()" [disabled]="working">
              Turn off
            </button>
          </div>
        </div>

        <!-- Subscription details, shown only while the feed is on -->
        @if (enabled && webcalUrl) {
          <div class="subscribe-panel">
            <a class="link-button subscribe-button" [href]="webcalUrl">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" y1="5" x2="12" y2="19"></line>
                <line x1="5" y1="12" x2="19" y2="12"></line>
              </svg>
              Add to my calendar
            </a>

            <div class="url-row">
              <input class="url-input" type="text" readonly [value]="httpsUrl" />
              <button class="copy-button" (click)="copyUrl()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
                Copy
              </button>
            </div>

            <p class="hint">
              On mobile, tap <strong>Add to my calendar</strong> and confirm. Otherwise paste
              the link into your calendar app's "Subscribe / Add by URL" option.
            </p>
          </div>
        }
      </div>
    </div>
  }
</edu-card>
